import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as summaryValueMapper from './summaryValueMapper';
import { findContactByType, isTseuCountry } from '../contactSearchAndFormat';
import Config from '../../Config';
import SummarySection from '../../components/Summary/SummarySection';
import accountTypesTexts from '../../components/AccountType/accountTypesTexts';
import * as accountTypesCodes from '../../components/AccountType/accountTypes';
import * as assetClassActions from '../../actions/assetClassActions';
import * as accountTypeActions from '../../actions/accountTypeActions';
import * as contactActions from '../../actions/contactActions';
import * as countriesActions from '../../actions/countriesActions';
import * as assetClassTexts from '../../components/AssetClass/assetClassTexts';
import * as summaryRowTypes from '../../components/Summary/summaryRowTypes';
import * as assetTypes from '../../components/AssetClass/assetTypes';
import {
  getAccountType,
  joinArray,
  getAssetClass,
  applyTsgoChanges,
} from '../../lib/containerHelpers/summary/summaryAccountTypeAssetFormContainerHelper';
import { investmentObjectiveOptions } from '../../components/AssetClass/assetClassTexts';

export class SummaryAccountTypeAssetContainer extends React.Component {
  componentDidMount() {
    if (!this.props.assetClass) {
      this.props.actions.fetchAssetClass(this.props.applicationId, this.props.authToken);
    }

    if (!this.props.accountType) {
      this.props.actions.fetchAccountType(this.props.applicationId, this.props.authToken);
    }

    if (!this.props.contact) {
      this.props.actions.fetchContact(this.props.applicationId, this.props.authToken);
    }

    if (!this.props.countries) {
      this.props.actions.fetchCountries();
    }
  }

  render() {
    return (
      <SummarySection {...this.props} />
    );
  }
}

SummaryAccountTypeAssetContainer.propTypes = {
  actions: PropTypes.shape({
    fetchAssetClass: PropTypes.func,
    fetchAccountType: PropTypes.func,
    fetchContact: PropTypes.func,
    fetchCountries: PropTypes.func.isRequired,
  }).isRequired,
  applicationId: PropTypes.string.isRequired,
  authToken: PropTypes.string.isRequired,
  assetClass: PropTypes.shape(),
  accountType: PropTypes.shape(),
  contact: PropTypes.shape(),
  countries: PropTypes.arrayOf(PropTypes.shape({
    country: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
  })),
};

const getInvestmentObjective = (optionsInvestmentGoals) => {
  return summaryValueMapper.getTextFromValue(investmentObjectiveOptions, optionsInvestmentGoals[0]);
};

function mapStateToInitialValues(state) {
  let isLoading = true;
  let accountType = accountTypesCodes.ACCOUNT_TYPE_INDIVIDUAL;
  let jointType = accountTypesCodes.JOINT_WITH_RIGHTS_OF_SURVIVORSHIP;
  let entityType = accountTypesCodes.ENTITY_CORPORATE;
  let iraType = accountTypesCodes.IRA_TRADITIONAL;
  const accountTypesValues = {};

  if (state.assetClass) {
    isLoading = false;
  }

  if (state.accountType) {
    if (state.accountType.accountType.indexOf('joint') > -1) {
      accountType = accountTypesCodes.ACCOUNT_TYPE_JOINT;
      jointType = state.accountType.accountType;
    } else if (state.accountType.accountType.indexOf('entity') > -1) {
      accountType = accountTypesCodes.ACCOUNT_TYPE_ENTITY;
      entityType = state.accountType.accountType;
    } else if (state.accountType.accountType.indexOf('ira') > -1) {
      accountType = accountTypesCodes.ACCOUNT_TYPE_IRA;
      iraType = state.accountType.accountType;
    } else {
      accountType = state.accountType.accountType;
    }
  }

  accountTypesValues.accountType = getAccountType(accountTypesTexts, accountType);
  accountTypesValues.entityType = getAccountType(accountTypesTexts, entityType);
  accountTypesValues.jointType = getAccountType(accountTypesTexts, jointType);
  accountTypesValues.iraType = getAccountType(accountTypesTexts, iraType);

  const accountTypeValue = accountTypesValues.accountType;
  const accountInformation = [
    {
      keyType: summaryRowTypes.SUMMARY_ROW_EDIT,
      valueType: summaryRowTypes.SUMMARY_ROW_EDIT,
      key: 'Account Setup',
      value: 'Account Setup Title',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Account Type',
      value: accountTypeValue,
    },
  ];

  const INDIVIDUAL_TEXT = getAccountType(accountTypesTexts, accountTypesCodes.ACCOUNT_TYPE_INDIVIDUAL);
  const ENTITY_TEXT = getAccountType(accountTypesTexts, accountTypesCodes.ACCOUNT_TYPE_ENTITY);
  const IRA_TEXT = getAccountType(accountTypesTexts, accountTypesCodes.ACCOUNT_TYPE_IRA);

  if (accountTypeValue !== INDIVIDUAL_TEXT) {
    let subTypeValue = '';
    if (accountTypeValue === ENTITY_TEXT) {
      subTypeValue = accountTypesValues.entityType;
    } else if (accountTypeValue === IRA_TEXT) {
      subTypeValue = accountTypesValues.iraType;
    } else {
      subTypeValue = accountTypesValues.jointType;
    }

    accountInformation.splice(2, 0,
      {
        keyType: summaryRowTypes.SUMMARY_ROW_TXT,
        valueType: summaryRowTypes.SUMMARY_ROW_TXT,
        key: `Type of ${accountTypeValue}`,
        value: subTypeValue,
      },
    );
  }
  /* ASSET CLASS */
  const assetClass = state.assetClass;
  const assetTypesList = state.accountType ? state.accountType.assetTypes : [];
  const numberOfAccounts = assetTypesList.filter(
    assetType => assetType !== assetTypes.ASSET_CLASS_TYPES_CRYPTO_WAITLIST,
  ).length;

  let assetInformation = [
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_BOX,
      key: 'Accounts to Open',
      value: assetTypesList ? joinArray(assetTypesList, assetClassTexts.assetClassTexts) : '',
    },
    {
      keyType: summaryRowTypes.SUMMARY_ROW_TXT,
      valueType: summaryRowTypes.SUMMARY_ROW_TXT,
      key: 'Number of Accounts',
      value: numberOfAccounts,
    },
  ];

  if (
    assetTypesList.includes(assetTypes.ASSET_CLASS_TYPES_EQUITIES) ||
    assetTypesList.includes(assetTypes.ASSET_CLASS_TYPES_CRYPTO_WAITLIST) ||
    assetTypesList.includes(assetTypes.ASSET_CLASS_TYPES_CRYPTO)) {
    const contact = findContactByType('primary', state.contact);
    const config = new Config();
    const tseuChangesEnabled = config.tseuChangesEnabled;
    if (!tseuChangesEnabled || (tseuChangesEnabled && !isTseuCountry(state.countries, contact.countryOfResidence))) {
      assetInformation = assetInformation.concat([
        {
          keyType: summaryRowTypes.SUMMARY_ROW_TXT,
          valueType: summaryRowTypes.SUMMARY_ROW_TXT,
          key: 'Fully Paid Lending',
          value: assetClass && assetClass.fullyPaidLendingProgram ? 'Yes' : 'No',
        },
      ]);
    }

    if (assetClass && assetClass.tradeStockOptions) {
      assetInformation = assetInformation.concat([
        {
          keyType: summaryRowTypes.SUMMARY_ROW_EDIT,
          valueType: summaryRowTypes.SUMMARY_ROW_EDIT,
          key: 'Account Settings',
          value: 'Account Settings Title',
          editLinkOverride: '/equities-account-settings',
        },
        {
          keyType: summaryRowTypes.SUMMARY_ROW_TXT,
          valueType: summaryRowTypes.SUMMARY_ROW_TXT,
          key: 'Equity Account Format',
          value: assetClass && assetClass.marginAccount ?
            getAssetClass(assetClassTexts.assetClassTexts, 'margin') :
            getAssetClass(assetClassTexts.assetClassTexts, 'cash'),
        },
        {
          keyType: summaryRowTypes.SUMMARY_ROW_TXT,
          valueType: summaryRowTypes.SUMMARY_ROW_TXT,
          key: 'Equity Options Trading',
          value: assetClass && assetClass.tradeStockOptions ? 'Yes' : 'No',
        },
        {
          keyType: summaryRowTypes.SUMMARY_ROW_TXT,
          valueType: summaryRowTypes.SUMMARY_ROW_TXT,
          key: 'Options Investment Objective',
          value: getInvestmentObjective(assetClass.optionsInvestmentGoals),
        },
        {
          keyType: summaryRowTypes.SUMMARY_ROW_TXT,
          valueType: summaryRowTypes.SUMMARY_ROW_TXT,
          key: 'Options Trading Level',
          value: assetClass ? assetClassTexts.stockOptionsTradingLevel(assetClass.optionsStrategies) : '',
        },
      ]);
    }
  }

  if (state.contact) {
    assetInformation = applyTsgoChanges(state, assetInformation);
  }

  Array.prototype.push.apply(accountInformation, assetInformation);
  return {
    isLoading,
    key: 'accountType',
    value: accountInformation,
    title: 'Accounts',
    editLink: '/account-type',
  };
}

function mapStateToProps(state) {
  const initialValues = mapStateToInitialValues(state);
  const errorMessage = '';

  return {
    applicationId: state.applicationId,
    authToken: state.authToken,
    isLoading: initialValues.isLoading,
    entity: initialValues.key,
    summaryInfo: initialValues.value,
    title: initialValues.title,
    editLink: initialValues.editLink,
    errorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({},
      assetClassActions,
      accountTypeActions,
      contactActions,
      countriesActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryAccountTypeAssetContainer);
